import { useEffect, useRef } from "react";
import { useUserContext } from "../../../../contexts/UserContext";
import { IOption } from "../../../../types";
import { StyledSetupsTabWrapper } from "../../../../utils/styled";
import {
  PageHeaderNavigationTab,
  rdsSetNavMenuHighlight,
} from "@cdkglobal/radial";
import { useUIStateContext } from "../../../../contexts/UIStateContext";
import {
  getHeaderSetupsList,
  handleSetupSelection,
} from "../../helpers";

export function SetupsDashboardNavTabs(): JSX.Element {
  const {
    selected,
    defaultStore,
    setSelected,
    setupListNavInfoByDepartment,
    iamUserState,
    permissions,
    setPermissions,
  } = useUserContext();
  const { setLandingPageToast } = useUIStateContext();
  const activeTabRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const activeTab = activeTabRef.current;
    if (activeTab && typeof activeTab.scrollIntoView === "function") {
      activeTab.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [selected.setup.value]);

  const { setupsOptions } = getHeaderSetupsList({
    selected,
    setupListNavInfoByDepartment,
  });

  const handleSetupClick = ({
    setup,
    department,
  }: {
    setup: IOption;
    department: IOption;
  }) => {
    handleSetupSelection({
      setup,
      department,
      store: defaultStore,
      setupListNavInfoByDepartment,
      setLandingPageToast,
      setSelected,
      iamUserState,
      permissions,
      setPermissions,
    });
    rdsSetNavMenuHighlight(setup.value);
  };

  if (setupsOptions.length === 0) return <></>;

  return (
    <StyledSetupsTabWrapper>
      {setupsOptions.map((setupOption) => {
        const isActive = selected.setup.value === setupOption.id;
        return (
          <PageHeaderNavigationTab
            key={setupOption.id}
            id={setupOption.id}
            data-testid={`${setupOption.id}-tab`}
            isActive={isActive}
            label={setupOption.text}
            ref={isActive ? activeTabRef : undefined}
            onClick={() =>
              setupOption.department &&
              handleSetupClick({
                setup: { value: setupOption.id, label: setupOption.text },
                department: setupOption.department,
              })
            }
          />
        );
      })}
    </StyledSetupsTabWrapper>
  );
}
